// /api/auth/recover

import { useMutation } from "@tanstack/react-query";
import fetchData from "../fetcher";
import { ForgetPasswordResponse, UseForgetPasswordParams } from "./types";


export const useForgetPassword = () => {
    return useMutation({
        mutationKey: ["useForgetPassword"],
        mutationFn: (params: UseForgetPasswordParams) => {
            return fetchData<ForgetPasswordResponse>("/iam/v4/auth/recover", {
                method: "POST",
                body: params,
            });
        },
    });
};